/* eslint-disable array-callback-return */
/* eslint-disable no-shadow */
import { Accordion, AccordionDetails, AccordionSummary, Box, useTheme, withStyles, withTheme } from '@material-ui/core';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import CrudTable from '../clients/details/crudTable.component';
import { enumColumn } from 'modules/common/enumTableColumn';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React, { useState } from 'react';
import Spinner from 'modules/common/spinner.component';
import classNames from 'classnames';
import { deleteAgent, getAgents, postAgent, putAgent } from 'modules/common/common.actions';
import { DELETE_AGENT_FAILURE, GET_AGENTS_FAILURE, POST_AGENT_FAILURE, PUT_AGENT_FAILURE } from 'modules/common/store/types';

const styles = theme => {
  return {
    row: {
      backgroundColor: theme.palette.common.white
    },
    inputGroup: {
      display: 'inline-flex',
      justifyContent: 'space-between'
    },
    root: {
      maxWidth: 170,
      marginRight: 10
    },
    extRoot: {
      width: 115,
      marginRight: 10
    },
    primaryContactRow: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      width: '100%'
    },
    primaryText: {
      paddingTop: 12,
      paddingRight: 5
    },
    newRow: {
      display: 'flex',
      flexDirection: 'column',
      maxWidth: 1050
    }
  };
};

const AgentsTable = props => {
  const theme = useTheme();
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const agentTypes = props.agentTypes && props.agentTypes.length > 0 ? props.agentTypes.filter(s => s.isActive === true) : [];

  const agentContactTypes =
    props.agentContactTypes && props.agentContactTypes.length > 0 ? props.agentContactTypes.filter(s => s.isActive === true) : [];

  const serviceRanks = props.serviceRanks && props.serviceRanks.length > 0 ? props.serviceRanks.filter(s => s.isActive === true) : [];

  const agentStatuses = props.agentStatuses && props.agentStatuses.length > 0 ? props.agentStatuses.filter(s => s.isActive === true) : [];

  const vendors = Array.isArray(props.vendors) ? props.vendors : [];

  // const addresses = Array.isArray(props.commonAddress) ? props.commonAddress : [];

  // const addressList = vendors.map(({ addressId, addressLineOne }) => ({
  //   id: addressId,
  //   title: addressLineOne ?? ''
  // }));

  const vendorList = vendors.map(({ vendorId, companyName }) => ({
    id: vendorId,
    title: companyName ?? ''
  }));

  const adjustedColumns = [
    {
      ...enumColumn('agentTypeId', agentTypes),
      header: 'Type',
      type: 'dropdown-v2',
      options: agentTypes,
      required: false,
      size: 50,
    },
    {
      ...enumColumn('vendorId', vendorList),
      header: 'Vendor',
      type: 'dropdown-v2',
      options: vendorList,
      required: false,
      size: 50,
    },
    {
      ...enumColumn('agentRankId', serviceRanks),
      header: 'Agent Rank',
      type: 'dropdown-v2',
      options: serviceRanks,
      required: false,
      size: 50,
    },
    {
      ...enumColumn('statusId', agentStatuses),
      header: 'Type',
      type: 'dropdown-v2',
      options: agentStatuses,
      required: false,
      size: 50,
    },
    {
      ...enumColumn('contactTypeId', agentContactTypes),
      header: 'Contact Type',
      type: 'dropdown-v2',
      options: agentContactTypes,
      required: false,
      size: 50,
    },
    { accessorKey: 'firstName', header: 'First Name', type: 'text', required: false, size: 50 },
    { accessorKey: 'lastName', header: 'Last Name', type: 'text', required: true, size: 70 },
    { accessorKey: 'companyName', header: 'Company', type: 'text', required: true, size: 70 },
    { accessorKey: 'phone', header: 'Phone', type: 'text', required: true, size: 50 },
    { accessorKey: 'code', header: 'Code', type: 'text', required: true, size: 50 },
    { accessorKey: 'email', header: 'Email', type: 'text', required: true, size: 50 },
    { accessorKey: 'fax', header: 'Fax', type: 'text', required: true, size: 50 }
  ];

  const updateRow = async (orgRow, newRow) => {
    setIsLoading(true);
    const values = orgRow.original;
    const normalizedValues = {
      ...values,
      firstName: values.firstName ?? '',
      lastName: values.lastName ?? '',
      companyName: values.companyName ?? '',
      code: values.code ?? '',
      phone: values.phone ?? '',
      mobileNumber: values.mobileNumber ?? '',
      tollFreePhone: values.tollFreePhone ?? '',
      email: values.email ?? '',
      fax: values.fax ?? '',
      website: values.website ?? '',
      taxId: values.taxId ?? '',
      notes: values.notes ?? '',
      citiesServed: values.citiesServed ?? '',
      zipCodesServed: values.zipCodesServed ?? '',
      masterRecCode: values.masterRecCode ?? '',
      addedBy: 1,
      addedOn: new Date(),
      modifiedBy: 1,
      modifiedOn: new Date(),
      agentAddressId: 4
    };

    const resp = await props.putAgent(orgRow.original.agentId, normalizedValues);
    if (resp.type === PUT_AGENT_FAILURE) {
      setIsLoading(false);
      return false;
    } else {
      const getResp = await props.getAgents();
      if (getResp.type === GET_AGENTS_FAILURE) {
        setIsLoading(false);
        return false;
      } else {
        setIsLoading(false);
        return true;
      }
    }
  };

  const createRow = async values => {
    setIsLoading(true);

    const normalizedValues = {
      ...values,
      firstName: values.firstName ?? '',
      lastName: values.lastName ?? '',
      companyName: values.companyName ?? '',
      code: values.code ?? '',
      phone: values.phone ?? '',
      mobileNumber: values.mobileNumber ?? '',
      tollFreePhone: values.tollFreePhone ?? '',
      email: values.email ?? '',
      fax: values.fax ?? '',
      website: values.website ?? '',
      taxId: values.taxId ?? '',
      notes: values.notes ?? '',
      citiesServed: values.citiesServed ?? '',
      zipCodesServed: values.zipCodesServed ?? '',
      masterRecCode: values.masterRecCode ?? '',
      addedBy: 1,
      addedOn: new Date(),
      modifiedBy: 1,
      modifiedOn: new Date(),
      agentAddressId: 4
    };

    const resp = await props.postAgent(normalizedValues);
    if (resp.type === POST_AGENT_FAILURE) {
      setIsLoading(false);
      return false;
    } else {
      const getResp = await props.getAgents();
      if (getResp.type === GET_AGENTS_FAILURE) {
        setIsLoading(false);
        return false;
      } else {
        setIsLoading(false);
        return true;
      }
    }
  };

  const deleteRow = async rowToDelete => {
    setIsLoading(true);
    const id = rowToDelete.original.agentId;
    const resp = await props.deleteAgent(id);
    if (resp.type === DELETE_AGENT_FAILURE) {
      return false;
    } else {
      const getResp = await props.getAgents();
      if (getResp.type === GET_AGENTS_FAILURE) {
        setIsLoading(false);
        return false;
      } else {
        setIsLoading(false);
        return true;
      }
    }
  };

  return (
    <Accordion
      expanded={isOpen}
      onChange={() => {
        setIsOpen(!isOpen);
      }}
      classes={{ root: classNames(props.classes.accordionStyleContacts) }}
    >
      <AccordionSummary
        expandIcon={
          <Box color={theme.palette.secondary.main}>
            <ExpandMoreIcon color="inherit" />
          </Box>
        }
      >
        <div className={props.classes.newRow}>
          <h2>Agents</h2>
        </div>
      </AccordionSummary>
      <AccordionDetails>
        {!isLoading && props.agents && (
          <div>
            <CrudTable
              editingMode={'modal'} // Can be changed to 'row' to edit inline
              columns={adjustedColumns}
              rows={props.agents}
              updateRow={updateRow}
              createRow={createRow}
              deleteRow={deleteRow}
            />
          </div>
        )}
        {isLoading && <Spinner />}
      </AccordionDetails>
    </Accordion>
  );
};

const mapStateToProps = state => {
  const { agentContactTypes, agentStatuses, agentTypes, serviceRanks } = state.enumerations.allEnums;
  const { agents, commonAddress, vendors } = state.common;

  return {
    agentContactTypes: agentContactTypes,
    agentStatuses: agentStatuses,
    agentTypes: agentTypes,
    serviceRanks: serviceRanks,
    agents: agents,
    commonAddress: commonAddress,
    vendors: vendors
  };
};

export default compose(
  withStyles(styles),
  withTheme,
  connect(mapStateToProps, {
    getAgents,
    putAgent,
    postAgent,
    deleteAgent
  })
)(AgentsTable);
